// eslint-disable-next-line import/prefer-default-export
export const buildLinks = () => {
  throw new Error("This component should not be used.")
};

const inPageNav = document.querySelector('.inpage-nav');
const inPageButton = document.querySelector('.in-page-button');
let parentSection = inPageNav;

// the same as colors in section.scss
const SECTION_COLORS = {
  gray: 'rgb(247, 247, 247)',
  blue: 'rgb(5, 16, 50)',
  lightBlue: 'rgb(39, 49, 78)',
  noBGColor: 'rgba(0, 0, 0, 0)',
}

if (inPageNav) {
  while (parentSection.parentNode) {
    if (parentSection.parentNode.tagName === 'SECTION') {
      parentSection = parentSection.parentNode;
      break;
    }
    parentSection = parentSection.parentNode;
  }

  const sectionBackgroundColor = window.getComputedStyle(parentSection).getPropertyValue('background-color');

  for (const key in SECTION_COLORS) {
    if (sectionBackgroundColor === SECTION_COLORS[key]) {
      inPageButton.classList.add(key);
    }
  }
}



// WEBPACK FOOTER //
// ./src/templates/components/market-subnav/market-subnav.js